import React from 'react';

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className = '',
}) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 px-6 text-center ${className}`}>
      {Icon && (
        <div
          className="p-4 rounded-2xl mb-4"
          style={{ backgroundColor: 'var(--color-bg-tertiary)' }}
        >
          <Icon size={32} style={{ color: 'var(--color-accent-primary)' }} />
        </div>
      )}
      {title && (
        <h3
          className="text-sm font-bold mb-2"
          style={{ color: 'var(--color-text-primary)' }}
        >
          {title}
        </h3>
      )}
      {description && (
        <p
          className="text-xs max-w-xs leading-relaxed mb-4"
          style={{ color: 'var(--color-text-muted)' }}
        >
          {description}
        </p>
      )}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="px-5 py-2 rounded-lg text-xs font-bold text-[var(--color-accent-contrast)] transition-all hover:brightness-110"
          style={{ backgroundColor: 'var(--color-accent-primary)' }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
